import TypeCoatingRequests from '../../server/typeCoating';
import { addLoading, removeLoading } from './loading';

export const getAllTypeCoating = (
  limit,
  skip,
  search,
  orderBy = 'DESC',
  field = 'createdAt',
  loading = true,
) => async (dispatch) => {
  if (loading) dispatch(addLoading());
  try {
    return await TypeCoatingRequests.getAllTypeCoating(limit, skip, search, orderBy, field);
  } finally {
    if (loading) dispatch(removeLoading());
  }
};

export const getTypeCoatingOptions = (search, loading = true) => async (dispatch) => {
  if (loading) dispatch(addLoading());
  try {
    return await TypeCoatingRequests.getTypeCoatingOptions(search);
  } finally {
    if (loading) dispatch(removeLoading());
  }
};

export const createTypeCoating = newTypeCoating => async (dispatch) => {
  dispatch(addLoading());
  try {
    await TypeCoatingRequests.createTypeCoating(newTypeCoating);
  } finally {
    dispatch(removeLoading());
  }
};

export const updateTypeCoating = updTypeCoating => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await TypeCoatingRequests.updateTypeCoating(updTypeCoating);
  } finally {
    dispatch(removeLoading());
  }
};
